var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playlist-group-view"},[_c('div',{staticClass:"header"},[_c('back-btn',{attrs:{"canReturn":_vm.canReturn,"backRoute":_vm.homeRoute,"shouldPop":_vm.shouldPop,"dark":""}})],1),_c('playlist-group',{attrs:{"playlistGroupId":_vm.playlistGroupId,"shouldAutoplay":_vm.shouldAutoplay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }